import { tiendasApi } from '../api'

export const descuentosSlice = tiendasApi.injectEndpoints({
    endpoints: builder => ({
        getDescuentos: builder.mutation({
            query: ({token}) => ({
                url: 'web/descuentos',
                method: 'GET',
                headers: {
                    'Authorization': token,
                }
            })
        }),
    })
})

export const {
    useGetDescuentosMutation,
} = descuentosSlice